import React from "react";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Skeleton,
} from "@mui/material";
import ErrorView from "../ErrorView/ErrorView";
import classes from "./DataTable.module.css";
import MUIButton from "../UI/MUIButton/MUIButton";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import InputSelectionComponent from "../../luminaire/Dashboard/Component/inputSelection";
import { useState } from "react";
import { useEffect } from "react";
import Modal from "../../Component/Modal/Modal";
import ContentMappingHistory from "../../luminaire/BrandAudit/ContentMapping/ContentMappingHistory"
import { dynamicReplace } from "../../luminaire/Dashboard/Component/ActionComponent/ActionModal";

const CONTENT_MAP_LLM_OPTIONS = [
  // {
  //   name: "gpt-4o",
  //   value: "gpt-4o",
  //   model: "gpt-4o",
  // },

  {
    name: "Claude-4",
    value: "Claude4",
    model: "claude-sonnet-4-20250514",
  },
  // {
  //   name: "Gemini-2.0",
  //   value: "Gemini",
  //   model: "gemini-2.0-flash",
  // },
  // {
  //   name: "Llama-3",
  //   value: "llama3",
  //   model: "llama-3-70B-Instruct",
  // },
];

const BuyingJourneyDataTable = ({
  data,
  loading,
  error,
  title,
  key,
  getBuyingJourneyData,
  headerName,
  handleContentMapping,
  isDisabled,
  selectedContentMapLlmItems,
  handleContentMapLlmCheckChange,
  filterOptions,
  shareComponent,
  isSharedView = false,
  pdfExportComponent,
  historyData = [],
  setFocusAreaInputs,
  setContentMapData,
  contentMappLimit
}) => {
  const [filter, setFilter] = useState([]);
  const [filterKeys, setFilterKeys] = useState(filterOptions || []);
  const [contentData, setContentData] = useState([]);
  const [showContentHistory, setShowContentHistory] = useState(false);
  useEffect(() => {
    if (data && data.length > 0) {
      setContentData(data);
    }
  }, [data]);
  useEffect(() => {
    if (filterOptions && filterOptions?.length > 0) {
      setFilterKeys(filterOptions)
    }
  }, [filterOptions])

  console.log('filterOptions', filterOptions, filterKeys  )
  function LoadingSkeletion() {
    return (
      <div className="p-3">
        <Skeleton variant="rectangular" height={30} />
        {Array(10)
          .fill(0)
          .map((_, index) => (
            <Skeleton
              variant="rectangular"
              width={index % 2 === 0 ? "70%" : "97%"}
              key={index}
              className="my-3"
              height={20}
            />
          ))}
      </div>
    );
  }
  const getContentHistory = (record) => {
    setFilter([]);
    setFocusAreaInputs(record?.focusAreaInputs)
    setContentMapData(record?.contentSuggestions);
    setShowContentHistory(false);
  }
  // const handleFilterChange = (selected) => {
  //   const selectedValues = selected?.map((option) => option?.name) || [];
  //   let data1 = [...data];
  //   if (selectedValues && selectedValues.length > 0) {
  //     data1 = data1?.filter((obj) => [selectedValues.at(-1)].includes(obj?.type));
  //   }
  //   setFilter(selectedValues.at(-1) ? [selectedValues.at(-1)] : []);
  //   setContentData(data1);
  // };
  const handleFilterChange = (selected) => {
    const selectedValues = selected?.map((option) => option?.value || option?.name) || [];

    let filtered = [...data];

    if (selectedValues.length > 0) {
      filtered = filtered.filter(obj => selectedValues.includes(obj?.type));
    }

    setFilter(selectedValues);
    setContentData(filtered);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 24px",
          marginBottom: "8px"
        }}
      >
        {/* Left side - Title aligned with table */}
        <Typography
          variant="h6"
          gutterBottom
          style={{
            margin: 0,
            fontWeight: 600,
            fontSize: "1.325rem"
          }}
        >
          {title}
        </Typography>

        {/* Right side - Buttons in order: Generate, ContentMapp History, shareComponent, pdfExportComponent */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flexWrap: "nowrap"
          }}
        >
          {contentMappLimit && contentMappLimit()}
          {!isSharedView && (
            <MUIButton
              onClick={handleContentMapping}
              variant="outlined"
              className={classes.regenerate}
              startIcon={<AutoAwesomeOutlinedIcon />}
              disabled={isDisabled}
              style={{
                height: "40px",
                whiteSpace: "nowrap",
                minWidth: "fit-content"
              }}
            >
              Generate
            </MUIButton>
          )}

          {!isSharedView &&
            historyData?.length > 0 &&
            !historyData.every(item => !item?.contentSuggestions || Object.keys(item.contentSuggestions).length === 0) && (
              <MUIButton
                onClick={() => setShowContentHistory(true)}
                variant="contained"
                color="primary"
                disabled={contentData?.length === 0}
                style={{
                  whiteSpace: "nowrap",
                  minWidth: "fit-content"
                }}
              >
                ContentMap History
              </MUIButton>
            )}

          {pdfExportComponent && (
            <div style={{ display: "flex", alignItems: "center" }}>
              {pdfExportComponent}
            </div>
          )}

          {shareComponent && (
            <div style={{ display: "flex", alignItems: "center" }}>
              {shareComponent}
            </div>
          )}
        </div>
      </div>

      {error && (
        <div className={classes.error}>
          <ErrorView
            title={"Error fetching data !"}
            message={error}
            retry
            onRetry={() => getBuyingJourneyData(key)}
          />
        </div>
      )}
      {loading && !error && <LoadingSkeletion />}
      {!loading && !error && data?.length > 0 && (
        <Card sx={{ m: 3, boxShadow: 3, borderRadius: 4 }}>
          <div
            style={{
              marginTop: "18px",
              marginLeft: '60%',
              width: "400px",
            }}
            className=" customTabContent col-md-3 position-relative"
          >
            <div className="input-group input-group-lg mb-3">
              <span className="input-group-text" id="basic-addon1">
                <i className="feather icon-target"></i>
              </span>

              <InputSelectionComponent
                selectedOptions={filter}
                handleChange={handleFilterChange}
                options={filterKeys}
                type="content_map_llm"
              />
            </div>
          </div>
          <CardContent>
            <TableContainer component={Paper} elevation={0}>
              <Table sx={{ minWidth: 650 }} aria-label="customized table">
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#4fd1c5" }}>
                    <TableCell align="center" sx={{ color: "#fff" }}>
                      Focus Area
                    </TableCell>
                    <TableCell align="center" sx={{ color: "#fff" }}>
                      Major Discussion Topic
                    </TableCell>
                    <TableCell align="center" sx={{ color: "#fff" }}>
                      Subtopic/Angle
                    </TableCell>
                    <TableCell align="center" sx={{ color: "#fff" }}>
                      Content Opportunity (Format)
                    </TableCell>
                    <TableCell align="center" sx={{ color: "#fff" }}>
                      Proposed Channels
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {contentData?.map((row, index) => (
                    <TableRow
                      key={row?.name}
                      sx={{
                        backgroundColor:
                          index % 2 === 0 ? "#f5f5f5" : "#ffffff",
                      }}
                    >
                      <TableCell align="center">{dynamicReplace(row?.theme)}</TableCell>
                      <TableCell align="center">{row?.majorTopic}</TableCell>
                      <TableCell align="center">{row?.subtopicAngle}</TableCell>
                      <TableCell align="center">{row?.format}</TableCell>
                      <TableCell align="center">{row?.channel}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}
      {showContentHistory && (
        <Modal
          open={showContentHistory}
          handleClose={() => setShowContentHistory(false)}
          title="ContentMap History"
          width="600px"
          height="50%"
        >
          <ContentMappingHistory
            historyData={historyData}
            getContentHistory={getContentHistory}
          />
        </Modal>
      )}
    </>
  );
};

export default BuyingJourneyDataTable;